import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'panel',
  template: require('./panel.component.html'),
  styles: [require('./panel.component.scss')],
})
export class PanelComponent {
  @Input() title: string;
  @Input() expanded: boolean;
  @Output() panelStateEmitter = new EventEmitter<boolean>();

  public emitPanelState(state: boolean, emitter: EventEmitter<boolean>): void {
    emitter.emit(state);
  }
}
